export const EQUIPMENT_KINDS = Object.freeze({
  ASIC: 'ASIC',
  PDU: 'PDU'
});

export const EQUIPMENT_STATUS = Object.freeze({
  MINING: 'MINING',
  OFFLINE: 'OFFLINE',
  DRAFT: 'DRAFT '
});
